import React, { useState, useEffect } from 'react';
import { Calendar, Bell } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Announcements = () => {
  const [announcementsData, setAnnouncementsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/announcements`);
      setAnnouncementsData(response.data);
    } catch (error) {
      console.error('Error fetching announcements:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <section className="pt-24 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Announcements
          </h1>
          <p className="text-lg text-gray-600">
            Important notices and updates from the Hiri Koiari DDA
          </p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto space-y-6">
          {loading ? (
            <div className="text-center py-12">
              <div className="text-lg text-gray-600">Loading announcements...</div>
            </div>
          ) : announcementsData.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-lg text-gray-600">No announcements available yet.</p>
            </div>
          ) : (
            announcementsData.map((announcement, index) => (
              <div
                key={announcement.id}
                className="bg-gradient-to-r from-yellow-50 to-orange-50 border-l-4 border-[#F5B700] rounded-r-xl p-6 hover:shadow-xl transform hover:-translate-x-1 transition-all duration-300"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#F5B700] rounded-full flex items-center justify-center flex-shrink-0">
                    <Bell className="w-6 h-6 text-gray-900" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 text-sm text-gray-600 mb-2">
                      <Calendar className="w-4 h-4" />
                      <time>{announcement.date}</time>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      {announcement.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">{announcement.content}</p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
};

export default Announcements;